import React, { Fragment, FunctionComponent, ReactElement, ReactNode } from 'react'

import styled from 'styled-components/native'

import { Divider } from '../../atoms/divider/Divider'
import { Title, Size as TitleSize } from '../../atoms/title/Title'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'
import { TaskListItem } from '../taskListItem/TaskListItem'

export type RecommendedAction = {
  id: string
  icon: ReactElement
  title: ReactNode
  onPress: () => void
}

export type RecommendedActionsProps = {
  title: ReactNode
  actions: RecommendedAction[]
  testID?: string
}

const Container = styled.View<{ theme: ThemeType }>(({ theme: { spacing } }) => ({
  gap: spacing['16px'],
}))

const List = styled.View<{ theme: ThemeType }>(({ theme: { colors } }) => ({
  backgroundColor: colors.backgroundPrimary,
  borderWidth: 1,
  borderColor: colors.borderDefault,
  borderStyle: 'solid',
  borderRadius: '16px',
  overflow: 'hidden',
}))

export const RecommendedActions: FunctionComponent<RecommendedActionsProps> = ({ title, actions, testID }) => {
  if (actions.length === 0) {
    return null
  }

  return (
    <Container testID={testID ?? tID('RecommendedActions')}>
      <Title size={TitleSize.XSMALL} text={title} />
      <List>
        {actions.map(({ id, icon, title: actionTitle, onPress }, index) => (
          <Fragment key={id}>
            {index > 0 && <Divider />}
            <TaskListItem testId={tID(`RecommendedActions-${id}`)} icon={icon} title={actionTitle} onPress={onPress} />
          </Fragment>
        ))}
      </List>
    </Container>
  )
}
